// Asia/Manila is a fixed UTC+8 offset (no DST) — mirrors the backend's
// services/worktime.manila_today(). `new Date().toISOString().slice(0, 10)`
// returns the *UTC* calendar date, which is a day behind Manila for the
// first eight hours of every local day: an HR user opening a date-scoped
// screen before 8am would default to yesterday. Shift by the fixed offset
// before taking the date part, rather than trusting the browser's UTC or
// local clock as-is.
const MANILA_OFFSET_MS = 8 * 60 * 60 * 1000;

// Accepts an optional Date/instant so callers (and tests) can pin "now"
// instead of depending on the wall clock.
export function manilaToday(now = new Date()) {
    return new Date(now.getTime() + MANILA_OFFSET_MS).toISOString().slice(0, 10);
}
